import React, { type FunctionComponent } from 'react'
import moment from 'moment'
import { css } from '@emotion/react'
import { Text } from '@retailer-platform/shared-components'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { useDashMessages } from 'intl/intl.hooks'
import { type HeroBannerDetailValues } from 'domains/merchandising/types/heroBanner.types'
import { dateFormat } from 'domains/merchandising/constants/heroBanner.constants'

const sectionContainer = css({
  display: 'flex',
  '& > div': {
    flex: '1 0 33%',
  },
})

export const HeroBannerDetailsDetail: FunctionComponent<HeroBannerDetailValues> = ({
  name,
  status,
  scheduling,
}) => {
  const messages = useDashMessages({
    emptyValue: 'merchandising.hero-banners.field.empty.value',
    placementNameLabel: 'merchandising.hero-banners.section.detail.field.placementName.label',
    activeDatesLabel: 'merchandising.hero-banners.section.detail.field.dates.label',
    statusLabel: 'merchandising.hero-banners.section.detail.field.status.label',
  })

  const { startDate, endDate, timezone } = scheduling
  const start = startDate ? moment(startDate).format(dateFormat) : messages.emptyValue
  const end = endDate ? moment(endDate).format(dateFormat) : messages.emptyValue

  return (
    <MerchandisingFormSection titleId="merchandising.hero-banners.section.content.title">
      <div css={sectionContainer}>
        <div>
          <Text weight="semibold">{messages.placementNameLabel}</Text>
          <Text size="medium">{name || messages.emptyValue}</Text>
        </div>
        <div>
          <Text weight="semibold">{messages.activeDatesLabel}</Text>
          <Text size="medium">{`${start} - ${end} (${timezone})`}</Text>
        </div>
        <div>
          <Text weight="semibold">{messages.statusLabel}</Text>
          <Text size="medium">{status || messages.emptyValue}</Text>
        </div>
      </div>
    </MerchandisingFormSection>
  )
}
